import React, {useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import useAPI from "../../../../hooks/useAPI";

import styledComponent from "styled-components";
import Spinner from "../../../plugins/Spinner";
import Select from "react-select";
import { sendToast } from "../../../plugins/toastAll";
import { ToastContainer } from "react-toastify";
import { NODE_THEMES } from "../Components/NodeTheme";

const ACCENT = "#0a7ba5";

const RemoveStatuses = ({
    statusModal,
    editFlow,
    isDark,
    countries,
    customStyles,
    customStylesDark
}) => {
    const { urlAPI_3, fetchWithAuth } = useAPI();
    const theme = isDark == 'true' ? NODE_THEMES.dark : NODE_THEMES.light;
    const {watch,register,handleSubmit,formState: { errors },reset,} = useForm({
        defaultValues: {
            phone: ""
        },
    });
    
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [selectedCountrie, setSelectedCountrie] = useState("");
    const [selectedClass, setSelectedClass] = useState("");
    const [errorCountrie, setErrorCountrie] = useState(false);

    // ------FUNCTIONS------

    //# Function para seleccionar codigo 
    const handleChange = (selectedCountrie) => {
        setErrorCountrie(false);
        setSelectedCountrie(selectedCountrie);
        setSelectedClass(selectedCountrie.callingCodes[0]);
    };

    //# Funcion para eliminar estados del bot
    const removeStatuses = async (data) => {
        setLoading(true);
        const dataStatuses = {
            phoneNumber: `+${selectedCountrie.callingCodes[0]}${data.phone}`,
            chatBotId: editFlow._id
        }
        const url = urlAPI_3 + "chatBot/removeStatuses";
        const options = { method: "POST", mode: "cors", body: JSON.stringify(dataStatuses)};
        const response = await fetchWithAuth(url, options);
        const result = await response.json();
        if(result.code == 1) {
            setLoading(false);
            sendToast({type: "error", message: result.message})
        } else {
            reset();
            setLoading(false);
            sendToast({type: "success", message: "Estados eliminados con éxito"})
        }
    }; 
    
    return (
        <>
            {loading ? (
                <div className="content-spinner">
                    <Spinner />
                </div>
            ) : null}

            <div 
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <form onSubmit={handleSubmit(removeStatuses)} style={{ width: "100%" }}>
                    <p style={{ fontSize: 12, color: theme.textSecondary, margin: "0 0 12px 0", lineHeight: 1.5 }}>
                        Borra el estado guardado de una conversación para que el bot vuelva a empezar desde el inicio con ese número.
                    </p>
                    <div>
                        <label htmlFor="phone" style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary, marginBottom: 5, display: "block" }}>Teléfono</label>
                        {/* Control unificado: prefijo de país + número dentro de una sola caja */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                height: "44px",
                                backgroundColor: theme.inputBg,
                                border: `1px solid ${errors.phone || errorCountrie ? "#FF2242" : theme.border}`,
                                borderRadius: "8px",
                                overflow: "hidden",
                            }}
                        >
                            <div style={{ width: "112px", flexShrink: 0 }}>
                                <Select
                                    styles={{
                                        ...(isDark == 'true' ? customStylesDark : customStyles),
                                        control: (provided) => ({ ...provided, backgroundColor: "transparent", border: "none", borderRadius: 0, boxShadow: "none", minHeight: "42px", cursor: "pointer" }),
                                        indicatorSeparator: () => ({ display: "none" }),
                                        valueContainer: (provided) => ({ ...provided, padding: "0 4px 0 10px" }),
                                        dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                                        menu: (provided) => ({ ...provided, minWidth: "260px", backgroundColor: theme.panelBg, border: `1px solid ${theme.border}`, borderRadius: "10px", overflow: "hidden" }),
                                        menuPortal: (base) => ({ ...base, zIndex: 1400 }),
                                    }}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    className="basic-multi-select"
                                    placeholder="+___"
                                    value={selectedCountrie}
                                    onChange={handleChange}
                                    options={countries}
                                    formatOptionLabel={(option, { context }) => (
                                    <div className="d-flex align-items-center" style={{fontSize: "13px"}}>
                                        <img src={option.flag} alt={option.name} style={{width: "18px", marginRight: "6px", flexShrink: 0, borderRadius: "2px"}} />
                                        {context === "value" ? (
                                            <span style={{whiteSpace: "nowrap", fontWeight: 600}}>+{option.callingCodes}</span>
                                        ) : (
                                            <span style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>(+{option.callingCodes}) {option.name}</span>
                                        )}
                                    </div>
                                    )}
                                    getOptionLabel={(option) => `${option.name} +${option.callingCodes}`}
                                    getOptionValue={(option) => option.name}
                                />
                            </div>
                            <div style={{ width: "1px", height: "22px", backgroundColor: theme.border, flexShrink: 0 }} />
                            <input
                                placeholder="300 000 0000"
                                style={{flex: 1, minWidth: 0, height: "100%", background: "transparent", border: "none", outline: "none", color: theme.textPrimary, fontStyle: "normal", fontSize: "14px", padding: "0 12px"}}
                                id="phone"
                                name="phone"
                                type="number"
                                min={0}
                                {...register("phone", {
                                    required: {
                                        value: true,
                                        message: "El teléfono es requerido.",
                                    },
                                    pattern: {
                                        value: /^[0-9]{7,11}$/i,
                                        message: "El formato no es correcto.",
                                    },
                                    minLength: {
                                        value: 7,
                                        message: "Mínimo 7 dígitos.",
                                    },
                                    maxLength: {
                                        value: 11,
                                        message: "Máximo 11 dígitos.",
                                    },
                                })}
                            />
                        </div>
                        {errors.phone && <Alert>* {errors.phone.message}</Alert>}
                        {errorCountrie && <Alert>* El código es requerido.</Alert>}
                    </div>  

                    <div className="d-flex justify-content-end mt-4" style={{ gap: "8px" }}>
                        <button
                            type="button"
                            onClick={() => {
                                reset();
                                statusModal(false);
                            }}
                            style={{ padding: "8px 18px", fontSize: "13px", fontWeight: 500, borderRadius: "8px", border: `1px solid ${theme.border}`, backgroundColor: "transparent", color: theme.textSecondary, cursor: "pointer" }}
                        >
                            Volver
                        </button>
                        <button
                            type="submit"
                            onClick={() => {
                                if (selectedCountrie) {
                                    setErrorCountrie(false)
                                } else {
                                    setErrorCountrie(true)
                                }
                            }}
                            style={{ padding: "8px 22px", fontSize: "13px", fontWeight: 600, borderRadius: "8px", border: "none", backgroundColor: ACCENT, color: "#fff", cursor: "pointer" }}
                        >
                            Limpiar
                        </button>
                    </div>
                </form>
            </div>

            <ToastContainer 
                position="top-center"
                autoClose={52000}
                // autoClose={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                // draggable
                theme={JSON.parse(localStorage.getItem("THEME")) ? "dark" : "light"}
                toastClassName="custom-toast" // Aplica estilos personalizados a cada toast individualmente
                bodyClassName="custom-toast-body"
            />
        </>
    )
}

export default RemoveStatuses;

const Alert = styledComponent.span`
  color: red;
  display: block;
  width: 100%;
  // width: 200px;
`;